import SlsTracker from '@aliyun-sls/web-track-browser'
import { getOS, getUserInfo, getChannel, getUA } from '@penguin/utils'
// 判断业务是否是 iphone、华为、小米、oppo、view、三星 打开
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import MobileDetect from 'mobile-detect'

function getOrCreateVisitorId() {
  let visitorId = localStorage.getItem('visitor_id')
  if (!visitorId) {
    visitorId = Math.random().toString(36).substr(2, 10) // 生成随机 ID
    localStorage.setItem('visitor_id', visitorId)
  }
  return visitorId
}

const channel = getChannel()

export const getUserData = async () => {
  if (getUA() === 'app') {
    const appUserInfo = getUserInfo() as UserInfo
    const userLocalInfo = localStorage.getItem('userLocalInfo')
    let userInfoParse: any = {}
    if (userLocalInfo) {
      userInfoParse = JSON.parse(userLocalInfo) as UserInfo
    }
    return appUserInfo.userId ? appUserInfo : userInfoParse
  } else {
    const userLocalInfo = localStorage.getItem('userLocalInfo')
    if (userLocalInfo) {
      return JSON.parse(userLocalInfo) as UserInfo
    }
    return {} as UserInfo
  }
}
export function judgeBrand(sUserAgent: any) {
  const isIphone = sUserAgent.match(/iphone/i) == 'iphone'
  const isHuawei = sUserAgent.match(/huawei/i) == 'huawei'
  const isHonor = sUserAgent.match(/honor/i) == 'honor'
  const isOppo = sUserAgent.match(/oppo/i) == 'oppo'
  const isOppoR15 = sUserAgent.match(/pacm00/i) == 'pacm00'
  const isVivo = sUserAgent.match(/vivo/i) == 'vivo'
  const isXiaomi = sUserAgent.match(/mi\s/i) == 'mi '
  const isXiaomi2s = sUserAgent.match(/mix\s/i) == 'mix '
  const isRedmi = sUserAgent.match(/redmi/i) == 'redmi'
  const isSamsung = sUserAgent.match(/sm-/i) == 'sm-'
  const isLG = sUserAgent.match(/lg/i) == 'lg'
  if (isIphone) {
    return 'iPhone'
  } else if (isHuawei || isHonor) {
    return 'Huawei'
  } else if (isOppo || isOppoR15) {
    return 'Oppo'
  } else if (isVivo) {
    return 'vivo'
  } else if (isXiaomi || isRedmi || isXiaomi2s) {
    return 'mi'
  } else if (isSamsung) {
    return 'Samsung'
  } else if (isLG) {
    return 'LG'
  } else {
    return '其他型号手机'
  }
}

export const detectMobile = () => {
  const userAgent = window.navigator.userAgent
  const md = new MobileDetect(userAgent)
  const os = md.os() // 获取系统
  let HMS: any = ''
  // 获取华为
  if (userAgent.split(')')[0].includes('HMSCore')) {
    HMS = userAgent.split(')')[0].split('HMSCore')[0].split(';')
  }
  let brand = 'unknown'
  let model = HMS[HMS.length - 2] || 'unknown'
  if (model) {
    brand = 'huawei'
  }
  if (os == 'iOS') {
    model = md.mobile()
    if (model == 'iPhone') {
      const iphoneArr = [
        ['440,956,3', 'A17', 'iPhone 16 Pro Max'],
        ['402,874,3', 'A17', 'iPhone 16 Pro'],
        ['430,932,3', 'A15', 'iPhone 14 Pro Max/(15 Plus/15 Pro Max/16 Plus)'],
        ['393,852,3', 'A15', 'iPhone 14 Pro/(15/15 Pro/16)'],
        ['375,812,3', 'A15', 'iPhone 13(12) min'],
        ['428,926,3', 'A14', 'iPhone 14(12/13) Plus'],
        ['390,844,3', 'A14', 'iPhone 14(12/13)'],
        ['414,896,3', 'A13', 'iPhone 11 Pro Max(Xs Max)'],
        ['375,812,3', 'A13', 'iPhone 11 Pro(X/Xs)'],
        ['414,896,2', 'A13', 'iPhone 11(XR)'],
        ['414,736,3', 'A12', 'iPhone 8(7/6s) Plus'],
        ['375,667,2', 'A11', 'iPhone 8(7/6)'],
        ['320,568,2', 'A11', 'iPhone 5(s/se)'],
        ['320,480,2', 'A10', 'iPhone 4(s)'],
      ]

      // 获取GPU信息
      const canvas = document.createElement('canvas'),
        gl = canvas?.getContext?.('experimental-webgl'),
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        debugInfo = gl?.getExtension?.('WEBGL_debug_renderer_info')
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const iphoneGPU = gl?.getParameter?.(debugInfo.UNMASKED_RENDERER_WEBGL)
      console.log('iphoneGPU', iphoneGPU)
      const width = window.screen.width
      const height = window.screen.height
      const devicePixelRatio = window.devicePixelRatio
      const baseInfo = width + ',' + height + ',' + devicePixelRatio
      iphoneArr.some((item) => {
        if (item[0] === baseInfo) {
          model = item[2]
        }
      })
      const os = +md?.version('iPhone')
      console.log('os', os)
      brand = 'iphone'
    } else {
      model = 'iPad'
      brand = 'iPad'
    }
  } else if (os == 'AndroidOS') {
    // Android系统的处理
    let j: any
    const sss = userAgent?.split(';')
    brand = sss?.[1]?.trim()
    for (let i = 0; i < sss.length; i++) {
      if (sss?.[i]?.indexOf?.('Build/') > 0) {
        j = i
        break
      }
    }
    if (j > -1) {
      model = sss?.[j]?.substring(0, sss?.[j]?.indexOf('Build/'))
    }
  }
  return {
    brand,
    model,
  }
}

const brandInfo = detectMobile()

const opts = {
  host: 'cn-shanghai.log.aliyuncs.com', // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: 'qiekj-web-log', // Project名称。
  logstore: 'integral-log', // Logstore名称。
  time: 10, // 发送日志的时间间隔，默认是10秒。
  count: 10, // 发送日志的数量大小，默认是10条。
  topic: 'topic', // 自定义日志主题。
  source: 'source',
  tags: {
    tags: 'tags',
  },
}

export const tracker = new SlsTracker(opts) // 创建SlsTracker对象

const os = getOS()

export const trackSendImmediate = async (extra: any = {}) => {
  const userInfo = await getUserData()
  tracker.sendImmediate({
    title: 'marketing-h5',
    data: JSON.stringify({
      channel,
      environment: 'h5',
      terminal: os,
      version: userInfo?.version,
      page: location.href,
      token: userInfo?.token || '',
      userId: userInfo?.userId || userInfo?.id,
      brand: userInfo?.brand || brandInfo?.brand,
      model: userInfo?.model || brandInfo?.model,
      visitorId: getOrCreateVisitorId(),
      ...extra,
    }),
  })
}
